module.exports = __webpack_public_path__ + "img/tencent.7f0fcc98.png";